import axios from 'axios';
import googleAnalyticsClient from '../common/google_analytics/ajax_handling';
import karteErrorClient from '../common/karte/error';

class ProductImageForIndex {
  product_data: any;
  galleries_data: any;

  async renderImages(wrapper: HTMLElement) {
    this.removeImageGalleries(wrapper);
    this.removeProductImages(wrapper);

    await this.fetchProducts(wrapper);
    await this.fetchImageGalleries(wrapper);

    if(sessionStorage.getItem('sort_official_image_checkbox') === 'checked') {
      // 公式画像から取得して並べる
      this.renderProductImages(wrapper, this.product_data as any);
      this.renderImageGalleries(wrapper, this.galleries_data as any);
    } else {
      // 画像ギャラリーから取得して並べる
      this.renderImageGalleries(wrapper, this.galleries_data as any);
      this.renderProductImages(wrapper, this.product_data as any);
    }
  }

  async fetchProducts(wrapper: HTMLElement) {
    this.product_data = [];
    type productAttributes = { id: string; image_url: string };
    type resultProducts = { data: Array<productAttributes> };

    // Productを取得してレンダリングする
    const name = this.updateStoreProductModal(wrapper).dataset.storeProductName || '';
    if (!name.length) {
      // 単商品名がない場合は処理しない
      return;
    }
    await axios
      .get<resultProducts>('/staff/api/products/fetch', {
        params: {
          name,
        },
      })
      .then(response => {
        this.product_data = response.data;
      })
      .catch(error => {
        // 単品商品の画像マスターを取得する処理でのエラー

        // エラーで使う変数
        const errorPath = '/staff/api/products/fetch';
        const errorMessage = '単品商品一覧で単品商品の画像マスターを取得する際にエラー発生';
        const el = document.querySelector<HTMLElement>('#staff_infomation');
        const staffId = el?.dataset.staffId;
        const now = el?.dataset.now;

        // エラーイベントを送信 (GA)
        if(staffId && now) {
          googleAnalyticsClient.error({
            time: now,
            path: errorPath,
            staffId: staffId,
            message: errorMessage
          });
        }

        // エラーイベントを送信 (KARTE)
        karteErrorClient.error({
          path: errorPath,
          message: errorMessage
        });
      });
  }

  // drag&dropで登録
  addDragDropEvent(wrapper: HTMLElement, targetElement: HTMLElement) {
    targetElement.addEventListener('drop', (event) => {
      event.preventDefault();
      const file = (event.dataTransfer as DataTransfer).files[0];
      const dt = new DataTransfer();
      dt.items.add(file);
      const productImageFileInput = this.getProductImageFileInput(wrapper);
      productImageFileInput.files = dt.files;
      productImageFileInput.dispatchEvent(new Event('change'));
    });

    targetElement.addEventListener('dragover', (event) => {
      event.preventDefault();
      (event.dataTransfer as DataTransfer).dropEffect = 'copy';
    });

    targetElement.addEventListener('dragleave', (event) => {
      event.preventDefault();
    });
  }

  async fetchImageGalleries(wrapper: HTMLElement) {
    this.galleries_data = [];
    type imageGalleryAttributes = { id: string; image_url: string };
    type resultImageGalleries = { data: Array<imageGalleryAttributes> };

    const name = this.updateStoreProductModal(wrapper).dataset.storeProductName || '';
    if (!name.length) {
      // 単商品名がない場合は処理しない
      return;
    }
    await axios
      .get<resultImageGalleries>('/staff/api/chirashiru_store_product_image_galleries/fetch', {
        params: {
          name,
        },
      })
      .then(response => {
        this.galleries_data = response.data;
      })
      .catch(error => {
        // 単品商品の画像ギャラリーを取得する処理でのエラー

        // エラーで使う変数
        const errorPath = '/staff/api/chirashiru_store_product_image_galleries/fetch';
        const errorMessage = '単品商品一覧で単品商品の画像ギャラリーを取得する際にエラー発生';
        const el = document.querySelector<HTMLElement>('#staff_infomation');
        const staffId = el?.dataset.staffId;
        const now = el?.dataset.now;

        // エラーイベントを送信 (GA)
        if(staffId && now) {
          googleAnalyticsClient.error({
            time: now,
            path: errorPath,
            staffId: staffId,
            message: errorMessage
          });
        }

        // エラーイベントを送信 (KARTE)
        karteErrorClient.error({
          path: errorPath,
          message: errorMessage
        });
      });
  }

  handleCheckboxChange() {
    const checkbox = document.querySelector('#sort_official_image_checkbox') as HTMLInputElement;

    // セッションストレージに値が含まれている場合、チェックボックスをチェックする
    const storedValue = sessionStorage.getItem('sort_official_image_checkbox');
    checkbox.checked = storedValue === 'checked';

    checkbox.addEventListener('change', function() {
      if (this.checked) {
        sessionStorage.setItem('sort_official_image_checkbox', 'checked');
      } else {
        sessionStorage.removeItem('sort_official_image_checkbox');
      }
    });
  }

  renderProductImages(wrapper: HTMLElement, products: Array<any>) {
    const registeredProductId = this.updateStoreProductModalBody(wrapper).dataset.registeredProductIdForInitialize;
    [].forEach.call(products, product => {
      const productId = product['id'];
      const productName = product['name'];
      const productImageUrl = product['image_url'];
      const div = document.createElement('div');
      div.classList.add('product-image');
      if (registeredProductId && registeredProductId == productId) {
        // すでに登録されている商品画像があれば、それにチェックを入れる (その処理は一度のみ)
        div.classList.add('selected');
        this.updateStoreProductModalBody(wrapper).dataset.registeredProductIdForInitialize = '';
      }
      div.dataset.productId = productId;
      div.dataset.productName = productName;
      const img = document.createElement('img');
      img.src = productImageUrl;
      img.classList.add('product-image-img');
      const span = document.createElement('span');
      span.innerText = productName;
      div.appendChild(img);
      div.appendChild(span);
      this.updateStoreProductModalBody(wrapper).appendChild(div);
      this.addEventToImage(wrapper, div);
    });
  }

  renderImageGalleries(wrapper: HTMLElement, imageGalleries: Array<any>) {
    [].forEach.call(imageGalleries, imageGallery => {
      const imageGalleryId = imageGallery['id'];
      const imageGalleryName = imageGallery['name'];
      const imageGalleryImageUrl = imageGallery['image_url'];
      const div = document.createElement('div');
      div.classList.add('image-gallery');
      div.dataset.imageGalleryId = imageGalleryId;
      div.dataset.imageGalleryName = imageGalleryName;
      const img = document.createElement('img');
      img.src = imageGalleryImageUrl;
      img.classList.add('image-gallery-img');
      const span = document.createElement('span');
      span.innerText = imageGalleryName;
      div.appendChild(img);
      div.appendChild(span);
      this.updateStoreProductModalBody(wrapper).appendChild(div);
      this.addEventToImageGrallery(wrapper, div);
      this.updateStoreProductModalBody(wrapper).appendChild(div);
      this.addEventToImage(wrapper, div);
    });
  }

  getProductImageFileInput(wrapper: HTMLElement) {
    const storeProductId = this.updateStoreProductModal(wrapper).dataset.storeProductId || '';
    return (wrapper.querySelector('#store_product_image_' + storeProductId) as HTMLInputElement);
  }

  addEventToImage(wrapper: HTMLElement, productImage: HTMLElement) {
    productImage.addEventListener('click', () => {
      this.updateProductId(wrapper, productImage);
    });
  }

  addEventToImageGrallery(wrapper: HTMLElement, imageGallery: HTMLElement) {
    imageGallery.addEventListener('click', () => {
      this.updateImageFromImageGallery(wrapper, imageGallery);
    });
  }

  removeProductImages(wrapper: HTMLElement) {
    const productImages = this.updateStoreProductModalBody(wrapper).querySelectorAll('.product-image');
    [].forEach.call(productImages, productImage => {
      (productImage as HTMLElement).remove();
    });
  }

  removeImageGalleries(wrapper: HTMLElement) {
    const imageGalleries = this.updateStoreProductModalBody(wrapper).querySelectorAll('.image-gallery');
    [].forEach.call(imageGalleries, imageGallery => {
      (imageGallery as HTMLElement).remove();
    });
  }

  getProductImageTd(wrapper: HTMLElement) {
    const storeProductId = this.updateStoreProductModal(wrapper).dataset.storeProductId || '';
    return (wrapper.querySelector('#product_image_' + storeProductId) as HTMLElement);
  }

  updateProductId(wrapper: HTMLElement, productImage: HTMLElement) {
    const productImageTd = this.getProductImageTd(wrapper) as HTMLElement;
    const productId = productImage.dataset.productId || '';
    const productName = productImage.dataset.productName || '';
    productImageTd.dataset.updateProductId = productId;
    productImageTd.dataset.updateProductName = productName;
    productImageTd.dispatchEvent(new Event('updateProductId'));
  }

  updateImageFromImageGallery(wrapper: HTMLElement, imageGallery: HTMLElement)  {
    const productImageTd = this.getProductImageTd(wrapper) as HTMLElement;
    const imageGalleryId = imageGallery.dataset.imageGalleryId || '';
    const imageGalleryName = imageGallery.dataset.imageGalleryName || '';
    productImageTd.dataset.updateImageGalleryId = imageGalleryId;
    productImageTd.dataset.updateImageGalleryName = imageGalleryName;
    productImageTd.dispatchEvent(new Event('updateImageGalleryId'));
  }

  updateStoreProductModal(wrapper: HTMLElement) {
    return wrapper.querySelector('#update_store_product_modal') as HTMLElement;
  }

  updateStoreProductModalBody(wrapper: HTMLElement) {
    return wrapper.querySelector('#update_store_product_modal_body') as HTMLElement;
  }

  productImageInputArea(wrapper: HTMLElement) {
    return wrapper.querySelector('#product_image_input_area') as HTMLElement;
  }

  updateStoreProductModalClose(wrapper: HTMLElement) {
    return wrapper.querySelector('#update_store_product_modal_close') as HTMLElement;
  }

  sortCheckBox(wrapper: HTMLElement) {
    return wrapper.querySelector('#sort_official_image_checkbox') as HTMLElement;
  }

  addEventForInitialize(wrapper: HTMLElement) {
    // 単品商品の画像更新モーダルがなければスキップ
    if (!this.updateStoreProductModal(wrapper)) {
      return;
    }

    this.handleCheckboxChange();

    this.addDragDropEvent(wrapper, this.productImageInputArea(wrapper));

    this.productImageInputArea(wrapper).addEventListener('click', () => {
      const productImageFileInput = this.getProductImageFileInput(wrapper);
      productImageFileInput.click();
    });

    this.updateStoreProductModalBody(wrapper).addEventListener('drop', (event) => {
      event.preventDefault();
    });

    this.updateStoreProductModalBody(wrapper).addEventListener('dragover', (event) => {
      event.preventDefault();
      (event.dataTransfer as DataTransfer).dropEffect = 'copy';
    });

    this.updateStoreProductModalClose(wrapper).addEventListener('click', () => {
      this.updateStoreProductModal(wrapper).style.display = 'none';
    });

    this.sortCheckBox(wrapper).addEventListener('click', () => {
      this.renderImages(wrapper);
    });

    this.updateStoreProductModal(wrapper).addEventListener('open', () => {
      this.renderImages(wrapper);
    });
  }

  initialize(wrapper: HTMLElement) {
    this.addEventForInitialize(wrapper);
  }
}

export default ProductImageForIndex;
